// extracted by mini-css-extract-plugin
export default {"cls1":"FocusedNav-cls1___277e5892a00e03005fd","cls2":"FocusedNav-cls2___a4c31cf09194fd0785d FocusedNav-cls1___277e5892a00e03005fd"};